import React from "react"
import {
  CommunicationChannel,
  CommunicationTemplateStatus,
} from "@mimber/schema"
import { MailOutlined, MessageOutlined, BellOutlined } from "@ant-design/icons"

export const CHANNEL_CONFIG: Record<
  CommunicationChannel,
  { label: string; color: string; icon: React.ReactNode }
> = {
  [CommunicationChannel.EMAIL]: {
    label: "Email",
    color: "blue",
    icon: React.createElement(MailOutlined),
  },
  [CommunicationChannel.SMS]: {
    label: "SMS",
    color: "green",
    icon: React.createElement(MessageOutlined),
  },
  [CommunicationChannel.PUSH]: {
    label: "Push",
    color: "purple",
    icon: React.createElement(BellOutlined),
  },
}

export const STATUS_CONFIG: Record<
  CommunicationTemplateStatus,
  { label: string; color: string }
> = {
  [CommunicationTemplateStatus.DRAFT]: { label: "Draft", color: "default" },
  [CommunicationTemplateStatus.ACTIVE]: { label: "Active", color: "success" },
  [CommunicationTemplateStatus.ARCHIVED]: {
    label: "Archived",
    color: "warning",
  },
}
